import { DateOnlyValue, toDateOnlyString } from "./dateOnly";

export interface ExpenseListFilters {
  startDate?: DateOnlyValue;
  endDate?: DateOnlyValue;
  userIds?: Array<string | number>;
  per_page?: number;
}

export function buildExpenseListQuery(
  page = 1,
  search: string | null = null,
  filters: ExpenseListFilters = {}
): string {
  const query = new URLSearchParams({ page: String(page) });
  const startDate = toDateOnlyString(filters.startDate);
  const endDate = toDateOnlyString(filters.endDate);

  if (search) query.set("vendor", search);
  if (startDate) query.set("start_date", startDate);
  if (endDate) query.set("end_date", endDate);
  if (filters.per_page) query.set("per_page", String(filters.per_page));
  filters.userIds?.forEach((userId) => {
    query.append("user_ids[]", String(userId));
  });

  return query.toString();
}
